import { Flex } from 'antd';

import { ServiceRowCard, ServiceRowCardVariant } from '@/shared/ui';

import { ResponseInsuranceOrder } from '@/modules/bia/shared/model/types';

interface Props {
  insuranceOrders: ResponseInsuranceOrder[];
}

export const InsuranceOrdersList: React.FC<Props> = ({ insuranceOrders }) => {
  return (
    <Flex vertical gap={16}>
      {insuranceOrders.map((insuranceOrder) => (
        <ServiceRowCard
          key={insuranceOrder.id}
          variant={ServiceRowCardVariant.INSURANCE_ORDER}
          insuranceOrder={insuranceOrder}
        />
      ))}
    </Flex>
  );
};
